import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './styles.pcss';
import { map } from './controller';

export { MapPointBaloon, MapSimpleBaloon } from './components';

const cx = classNames.bind(styles);

export class YAMap extends React.PureComponent {
  componentDidMount() {
    const {
      pins,
      points,
      isMobile,
      center,
      hasClusters,
      onBaloonClose,
      onBaloonOpen,
      customMapState,
      customMapOptions,
      mobileOptions,
      customPlacemarkOptions,
      customClustererOptions,
      mapId,
      children,
    } = this.props;
    map.loadYandexMapScripts({
      pins,
      points,
      isMobile,
      center,
      hasClusters,
      onBaloonClose,
      onBaloonOpen,
      customMapState,
      customMapOptions,
      mobileOptions,
      customPlacemarkOptions,
      customClustererOptions,
      mapId,
      children,
    });
  }

  componentDidUpdate(prevProps) {
    const { points, isMobile, mapId } = this.props;
    const { prevIsMobile } = prevProps;
    map.update(points, prevIsMobile, isMobile, mapId);
  }

  render() {
    const { isMobile, className, mapId } = this.props;
    return (
      <div className={cx('wrapper', isMobile && 'mobile')}>
        <div className={cx('block', className)} id={mapId} />
      </div>
    );
  }
}

YAMap.defaultProps = {
  points: [],
  hasClusters: false,
  onBaloonClose: () => {},
  onBaloonOpen: () => {},
  customMapState: {},
  customMapOptions: {},
  customPlacemarkOptions: {},
  customClustererOptions: {},
  mapId: 'yamap',
  mobileOptions: {},
};

YAMap.propTypes = {
  points: PropTypes.array,
  isMobile: PropTypes.bool,
  prevIsMobile: PropTypes.bool,
  center: PropTypes.arrayOf(PropTypes.number),
  hasClusters: PropTypes.bool,
  children: PropTypes.func,
  onBaloonClose: PropTypes.func,
  onBaloonOpen: PropTypes.func,
  pins: PropTypes.object,
  customMapState: PropTypes.object,
  customMapOptions: PropTypes.object,
  customPlacemarkOptions: PropTypes.object,
  customClustererOptions: PropTypes.object,
  mobileOptions: PropTypes.object,
  className: PropTypes.string,
  mapId: PropTypes.string, // should be unique for correct map work
};
